
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(134|429|542|954)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
